import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivationStart, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/store';
import * as fromLocationsSelectors from '../../../../store/selectors/locations/locations.selectors';

@Component({
  selector: 'lns-location-details',
  templateUrl: './location-details.component.html',
  styleUrls: ['./location-details.component.scss']
})
export class LocationDetailsComponent implements OnInit {
  locationsData$!: Observable<fromLocationsSelectors.LocationsModel>;
  locations: any;
  selectedLocation: any;
  selectedLocationId: any;

  constructor(private store: Store<AppState>, private activatedRoute: ActivatedRoute, private router: Router) {
    this.locationsData$ = this.store.pipe(
      select(fromLocationsSelectors.selectLocations)
    );
  }
  
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
          this.selectLocation(event);
      }
  });
  this.selectLocation(this.activatedRoute)
  }

  selectLocation(event:any) {
    this.selectedLocationId = event.snapshot.params.locationId;
    this.locationsData$.subscribe(res => {
      if (res.locations) {
        this.locations = res.locations;
        this.selectedLocation = this.locations.find((location:any)=> location.id == this.selectedLocationId);
      }
    });
  }
}
